import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';
import { cn } from '@/lib/utils';
import type { HubV2State } from './hooks/useHubV2State';

export default function LiveResultsPanel({ state }: { state: HubV2State }) {
  const { r } = state;
  const ssColor = r.ss >= 85 ? 'text-green-600' : r.ss >= 70 ? 'text-amber-600' : 'text-red-500';

  return (
    <div className="mt-4 bg-white rounded-xl border border-[#D9E2EC] shadow-sm p-4">
      <div className="text-xs font-bold text-[#0B1F4A] mb-3">📊 Live Simulatie Resultaten</div>

      <div className="grid grid-cols-3 md:grid-cols-6 gap-2 mb-4">
        {[
          { icon: '☀️', label: 'PV', value: `${r.pv.toFixed(0)} MWh` },
          { icon: '🔌', label: 'Vraag', value: `${r.dem.toFixed(0)} MWh`, extra: undefined as string | undefined },
          { icon: '✅', label: 'Zelf', value: `${r.ss.toFixed(1)}%`, extra: ssColor },
          { icon: '⚡', label: 'Grid', value: `${r.gi.toFixed(0)} MWh` },
          { icon: '🏭', label: 'Backup', value: `${r.bu.toFixed(0)} MWh` },
          { icon: '✂️', label: 'Curtailed', value: `${r.curt.toFixed(0)} MWh` },
        ].map((kpi, i) => (
          <div key={i} className="text-center p-2 rounded-lg bg-[#F8FAFC] border border-[#E2E8F0]">
            <div className="text-[10px] text-[#8899AA]">{kpi.icon} {kpi.label}</div>
            <div className={cn("text-xs font-bold", kpi.extra)}>{kpi.value}</div>
          </div>
        ))}
      </div>

      <ResponsiveContainer width="100%" height={120}>
        <BarChart data={r.monthly} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
          <XAxis dataKey="m" tick={{ fontSize: 8 }} />
          <YAxis hide />
          <Tooltip />
          <Bar dataKey="pv" name="PV" fill="#0891B2" radius={[2, 2, 0, 0]} barSize={8} />
          <Bar dataKey="dem" name="Vraag" fill="#1E3A5F" radius={[2, 2, 0, 0]} barSize={8} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
